export interface IDonorProfilePostTransplant {
    recipientId: number
    whichKidneyDonated: string
    isWillingToMeetDonor?: boolean
    isSharingGfAndCreatinine?: boolean
    graftSurvival?: boolean
    creatinineDate: string
    creatinineValue: string
    insurance: string
    relationshipToSubscriber: string
    globalCaseRate?: boolean
    policyIdNumber: string
    groupNumber: string
    professionalCaseRate?: boolean
    lastUpdated: string
    precertificationPhone: string
    benefitPhone: string
    caseManagerName: string
    caseManagerPhone: string,
    crossClampDateTime: string,
    perfusionCompletionDateTime: string,
    completedFormsAndChecklistsUploadPath: string,
    scheduledPickupDateTime: string
}